"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("../SvgIcon"));
function factorySvgIcon(IconComp) {
    var Component = function (props, ref) {
        return react_1.default.createElement(SvgIcon_1.default, __assign({ IconComp: IconComp }, props, { forwardedRef: ref }));
    };
    return react_1.default.memo(react_1.default.forwardRef(Component));
}
exports.default = factorySvgIcon;
//# sourceMappingURL=factorySvgIcon.js.map